/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgencyContactDto } from '../models/agency-contact-dto';
import { apiAgencycontactAgencyAgencyGuidGet } from '../fn/agency-contact/api-agencycontact-agency-agency-guid-get';
import { ApiAgencycontactAgencyAgencyGuidGet$Params } from '../fn/agency-contact/api-agencycontact-agency-agency-guid-get';
import { apiAgencycontactGet } from '../fn/agency-contact/api-agencycontact-get';
import { ApiAgencycontactGet$Params } from '../fn/agency-contact/api-agencycontact-get';
import { apiAgencycontactGuidGet } from '../fn/agency-contact/api-agencycontact-guid-get';
import { ApiAgencycontactGuidGet$Params } from '../fn/agency-contact/api-agencycontact-guid-get';
import { apiAgencycontactPost } from '../fn/agency-contact/api-agencycontact-post';
import { ApiAgencycontactPost$Params } from '../fn/agency-contact/api-agencycontact-post';
import { apiAgencycontactPut } from '../fn/agency-contact/api-agencycontact-put';
import { ApiAgencycontactPut$Params } from '../fn/agency-contact/api-agencycontact-put';

@Injectable({ providedIn: 'root' })
export class AgencyContactService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgencycontactGet()` */
  static readonly ApiAgencycontactGetPath = '/api/agencycontact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencycontactGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencycontactGet$Response(params?: ApiAgencycontactGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgencyContactDto>>> {
    return apiAgencycontactGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencycontactGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencycontactGet(params?: ApiAgencycontactGet$Params, context?: HttpContext): Observable<Array<AgencyContactDto>> {
    return this.apiAgencycontactGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgencyContactDto>>): Array<AgencyContactDto> => r.body)
    );
  }

  /** Path part for operation `apiAgencycontactPut()` */
  static readonly ApiAgencycontactPutPath = '/api/agencycontact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencycontactPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencycontactPut$Response(params?: ApiAgencycontactPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgencycontactPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencycontactPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencycontactPut(params?: ApiAgencycontactPut$Params, context?: HttpContext): Observable<void> {
    return this.apiAgencycontactPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgencycontactPost()` */
  static readonly ApiAgencycontactPostPath = '/api/agencycontact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencycontactPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencycontactPost$Response(params?: ApiAgencycontactPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgencycontactPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencycontactPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencycontactPost(params?: ApiAgencycontactPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAgencycontactPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgencycontactAgencyAgencyGuidGet()` */
  static readonly ApiAgencycontactAgencyAgencyGuidGetPath = '/api/agencycontact/agency-{agencyGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencycontactAgencyAgencyGuidGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencycontactAgencyAgencyGuidGet$Response(params: ApiAgencycontactAgencyAgencyGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgencyContactDto>>> {
    return apiAgencycontactAgencyAgencyGuidGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencycontactAgencyAgencyGuidGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencycontactAgencyAgencyGuidGet(params: ApiAgencycontactAgencyAgencyGuidGet$Params, context?: HttpContext): Observable<Array<AgencyContactDto>> {
    return this.apiAgencycontactAgencyAgencyGuidGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgencyContactDto>>): Array<AgencyContactDto> => r.body)
    );
  }

  /** Path part for operation `apiAgencycontactGuidGet()` */
  static readonly ApiAgencycontactGuidGetPath = '/api/agencycontact/{guid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencycontactGuidGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencycontactGuidGet$Response(params: ApiAgencycontactGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgencyContactDto>> {
    return apiAgencycontactGuidGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencycontactGuidGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencycontactGuidGet(params: ApiAgencycontactGuidGet$Params, context?: HttpContext): Observable<AgencyContactDto> {
    return this.apiAgencycontactGuidGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgencyContactDto>): AgencyContactDto => r.body)
    );
  }

}
